import jsPDF from "jspdf";

const PrintKitchenCardMulti = async (order) => {
  const createdDate = new Date(order.createdAt || Date.now());
  const mm = String(createdDate.getMonth() + 1).padStart(2, "0");
  const dd = String(createdDate.getDate()).padStart(2, "0");
  const yyyy = createdDate.getFullYear();
  const formattedDate = `${mm}-${dd}-${yyyy}`;

  for (let index = 0; index < order.items.length; index++) {
    const item = order.items[index];
    let y = 10;

    const paperWidth = 58;
    const checkboxSize = 4;
    const optCheckboxSize = 3;
    const marginLeft = 3;
    const spaceBetweenCheckboxAndText = 2;

    const textX = marginLeft + checkboxSize + spaceBetweenCheckboxAndText;
    const lineHeight = 4.5;
    const optLineHeight = 4;

    const measurer = new jsPDF({ unit: "mm" });

    const qtyFontSize = 11;
    const nameFontSize = 11;
    const optFontSize = 9;

    const qtyLine = `${item.amount}pc/s`;
    const maxNameWidth = paperWidth - textX - 2;

    measurer.setFont("helvetica", "bold");
    measurer.setFontSize(nameFontSize);
    const nameWrapped = measurer.splitTextToSize(
      String(item.name ?? "").trim(),
      maxNameWidth
    );

    const optCheckX = textX + 1;
    const optTextX = optCheckX + optCheckboxSize + spaceBetweenCheckboxAndText;
    const maxOptWidth = paperWidth - optTextX - 2;

    let optionsWrapped = [];
    let optionsLines = 0;
    if (Array.isArray(item.options) && item.options.length > 0) {
      measurer.setFont("helvetica", "normal");
      measurer.setFontSize(optFontSize);
      optionsWrapped = item.options.map((opt) => {
        const choices = Array.isArray(opt.choices)
          ? opt.choices.map((c) => String(c).trim()).join(", ")
          : "";
        const line = `${opt.name}: ${choices}`.trim();
        const lines = measurer.splitTextToSize(line, maxOptWidth);
        optionsLines += lines.length;
        return lines;
      });
    }

    const baseHeaderHeight = 10 + 6 + 4 + 8;
    const itemBlockHeight = lineHeight + nameWrapped.length * lineHeight + 2;
    const optionsBlockHeight =
      optionsLines * optLineHeight + (optionsLines > 0 ? 2 : 0);
    const tailPad = 10;

    const contentHeight =
      baseHeaderHeight + itemBlockHeight + optionsBlockHeight + tailPad;

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [paperWidth, contentHeight],
    });

    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(`Order #: ${order.orderNumber}`, marginLeft, y);

    doc.setFontSize(18);
    let statusText = "TO";
    let statusColor = "#0277bd";
    if (
      typeof order.tentNumber === "string" &&
      order.tentNumber.toLowerCase().includes("fmeal")
    ) {
      statusText = "FM";
      statusColor = "#c792ea";
    } else if (order.salesType === "Dine-In") {
      statusText = "DI";
      statusColor = "#2e7d32";
    } else if (order.salesType === "Delivery") {
      statusText = "DEL";
      statusColor = "orange";
    }

    const rightMargin = 4;
    const statusWidth = doc.getTextWidth(statusText);
    const statusX = Math.max(
      marginLeft,
      paperWidth - rightMargin - statusWidth - 1
    );

    doc.setTextColor(statusColor);
    doc.text(statusText, statusX, y + 2);
    doc.setTextColor(0);

    y += 6;
    doc.setFontSize(10);
    doc.text(`Tent #: ${order.tentNumber}`, marginLeft, y);
    y += 4;

    doc.setFontSize(8);
    doc.text("----------------------------------", paperWidth / 2, y, {
      align: "center",
    });
    y += 8;

    doc.rect(marginLeft, y - 3, checkboxSize, checkboxSize);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(qtyFontSize);
    doc.text(qtyLine, textX, y);

    doc.setFontSize(nameFontSize);
    const nameStartY = y + lineHeight;
    nameWrapped.forEach((line, i) => {
      doc.text(line, textX, nameStartY + i * lineHeight);
    });

    y = nameStartY + nameWrapped.length * lineHeight + 2;

    if (optionsWrapped.length > 0) {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(optFontSize);
      optionsWrapped.forEach((optLines) => {
        doc.rect(optCheckX, y - 3, optCheckboxSize, optCheckboxSize);
        optLines.forEach((l, j) => {
          doc.text(l, optTextX, y + j * optLineHeight);
        });
        y += optLines.length * optLineHeight + 1;
      });
    }

    const filename = `${formattedDate}-${order.orderNumber}-${index + 1}.pdf`;

    try {
      const blob = doc.output("blob");
      const url = URL.createObjectURL(blob);
      let w = window.open(url, "_blank");
      if (!w || w.closed) {
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.rel = "noopener";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
      setTimeout(() => {
        try {
          URL.revokeObjectURL(url);
        } catch (e) {}
      }, 120000);
    } catch (e) {
      console.error("Error opening PDF blob:", e);
    }

    await new Promise((resolve) => setTimeout(resolve, 3500));
  }
};

export default PrintKitchenCardMulti;
